import { render, staticRenderFns } from "./LivestreamBusinesses.vue?vue&type=template&id=f74ded70&scoped=true&"
import script from "./LivestreamBusinesses.vue?vue&type=script&lang=js&"
export * from "./LivestreamBusinesses.vue?vue&type=script&lang=js&"
import style0 from "./LivestreamBusinesses.vue?vue&type=style&index=0&id=f74ded70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74ded70",
  null
  
)

export default component.exports